import { AdminPanelName, HistoryStackEntry } from '../../../state';
import { Button, ButtonIcon, ButtonText } from '@mint/ui';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AdminPanelBackButtonProps } from './admin-panel-back-button-props';
import { ArrowLeftIcon } from '@mint/icons';
import { getPreviousAdminPanelsHistoryEntry } from '../../../selectors';
import { popAdminPanel } from '../../../actions';
import styled from 'styled-components';

const mapPreviousEntryToLabel = (
  entry: HistoryStackEntry<AdminPanelName, any> | null,
): React.ReactNode => {
  const name = entry && entry.name;

  switch (name) {
    case AdminPanelName.Page:
      return 'Page';
    case AdminPanelName.Event:
      return 'Event';
    case AdminPanelName.Place:
      return 'Place';
    case AdminPanelName.Home:
    default:
      return 'Main Menu';
  }
};

export const AdminPanelBackButtonComponent: React.FunctionComponent<
  AdminPanelBackButtonProps
> = (props): React.ReactElement => {
  const dispatch = useDispatch();

  const previousHistoryEntry = useSelector(getPreviousAdminPanelsHistoryEntry);

  const onClick = useCallback((): void => {
    dispatch(popAdminPanel());
  }, []);

  return (
    <Button
      {...props}
      onClick={onClick}
      noInk
      noHoverStyles
      iconLeft={<ArrowLeftIcon style={{ top: '0.18em' }} />}
    >
      {mapPreviousEntryToLabel(previousHistoryEntry)}
    </Button>
  );
};

export const AdminPanelBackButton = styled(AdminPanelBackButtonComponent)`
  margin-left: -${(props): string => props.theme.ms(-1, 'em')};
  opacity: 0.8;
  transition: opacity 120ms;

  & svg {
    transform: scale(1.2) translateX(2px);
    transform-origin: center right;
    transition: transform 340ms cubic-bezier(0.09, 0.73, 0.84, 0.94);
    top: 2px;
    opacity: 0.7;
  }

  & ${ButtonText} {
    text-transform: uppercase;
    letter-spacing: 0.8px;
  }

  :hover {
    opacity: 1;

    & svg {
      transform: scale(1.2) translateX(-1px);
    }
  }
`;
